module.exports = __webpack_public_path__ + "img/client-logo-refit.5c23e3bd.png";